import { useAppSelector } from '@/store/hooks';
import { selectFootTrafficRanking } from '@/store/selectors/attribution/footTraffic.selectors';
import { Chip } from '@mui/material';

const RankingBadge = () => {
  const { competitiveRanking } = useAppSelector(selectFootTrafficRanking);
  const dma = competitiveRanking?.byCategory.dma;
  if (!competitiveRanking || !dma) return null;

  const categorySuffix = competitiveRanking.category ? ` — ${competitiveRanking.category} category` : '';
  const label = `#${dma.rank} in Market of ${dma.total}${categorySuffix}`;

  return <Chip label={label} size='small' sx={{ bgcolor: 'grey.100' }} role='status' />;
};

export default RankingBadge;
